var getGroupHeaderPosition = function getGroupHeaderPosition(string) {
  return string.match(/group(.*)/g)[0].match(/[0-9]/g)[0];
};

export { getGroupHeaderPosition };
//# sourceMappingURL=utils.js.map
